import { CloseOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-relay';
import { MutationParameters, PayloadError } from 'relay-runtime';
import styled from 'styled-components';

import { AttachmentFragment$data } from '../../graphql/__generated__/AttachmentFragment.graphql';
import DeleteAttachmentMutation from '../../graphql/mutations/DeleteAttachmentMutation';
import { ComponentsDispatch } from '../../store';
import { addSpinnerItem, removeSpinnerItem } from '../../store/slices/spinnerSlice';

interface IAttachmentDeleteButton {
    attachment: AttachmentFragment$data;
    connectionId: string;
    model_id: string;
    model_type: string;
}

const StyledButton = styled(Button)`
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(255, 255, 255, 0.7);
`;

const AttachmentDeleteButton: React.FC<IAttachmentDeleteButton> = ({
    attachment,
    connectionId,
    model_id,
    model_type,
}) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const [commitDelete, isInFlightDelete] = useMutation(DeleteAttachmentMutation);

    useEffect(() => {
        if (isInFlightDelete) {
            dispatch(addSpinnerItem('deleteAttachment'));
        }
    }, [isInFlightDelete]);

    const handleRemoveAttachment = (id: string) => () => {
        commitDelete({
            variables: {
                input: {
                    model_type: model_type,
                    model_id: model_id,
                    document_id: id,
                },
                connections: [connectionId],
            },
            onCompleted: (response: any, errors: PayloadError[]) => {
                if (errors) {
                    console.log(
                        (
                            errors[0] as PayloadError & {
                                extensions: { debugMessage: string };
                            }
                        ).extensions.debugMessage,
                        errors,
                    );
                }
                dispatch(removeSpinnerItem('deleteAttachment'));
            },
        } as any as MutationParameters);
    };

    return (
        <div
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <Popconfirm
                title="Delete the item"
                description="Are you sure you want to delete this item?"
                onConfirm={handleRemoveAttachment(attachment.id)}
                okText="Yes"
                cancelText="No"
            >
                <StyledButton type="text" icon={<CloseOutlined />} className="remove-button" />
            </Popconfirm>
        </div>
    );
};

export default AttachmentDeleteButton;
